import { Grid } from "@mui/material";
import AdVideoItem from "pages/advertisement/ad_videos/AdVideoItem";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  adsVideoSelector,
  getVideosThunk,
} from "store/reducers/advertisement/adsVideoSlice";

const AdVideoList = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getVideosThunk());
  }, []);
  const videos = useSelector(adsVideoSelector.selectAll);
  const drawerOpen = useSelector((state) => state.menu.drawerOpen);
  return (
    <>
      <Grid container spacing={1} marginTop={1}>
        {videos.map((video) => (
          <Grid
            item
            xl={3}
            lg={drawerOpen ? 4 : 3}
            md={6}
            xs={12}
            key={video.id}
          >
            <AdVideoItem item={video} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default AdVideoList;
